import { SerializableObject } from '../../common-react/core';

import { ShipmentDirection } from '../other/shipment-direction.enum';
import { ShipmentStatus } from '../other/shipment-status.enum';
import { SummarizedShipmentStatus } from '../other/summarized-shipment-status.enum';

import { CustomsInfo } from './customs-info.do';
import { Label } from './label.do';
import { Party } from './party.do';
import { ShipmentOptions } from './shipment-options.do';

// DTO Object for representing a shipment
export class Shipment extends SerializableObject {
  /**
   * NOTE: Shipment ID is in fact the Tracking Number of the shipment.
   *
   * @see mobiz-posturinn-extension:Posturinn.Extension.Service.Postal.Mappers.IndexToDTOMapper.Map()
   */
  public id: string;

  public canAddDocuments: boolean;
  public canSeeShipmentDetails: boolean;
  public customsInfo?: CustomsInfo;
  public deliveryServiceId: string;
  public destinationLocationId?: string;
  public direction: ShipmentDirection;
  public isMissingDocuments?: boolean;
  public isMissingDocumentsMessage?: string;
  public isPayable?: boolean;
  public options?: ShipmentOptions;
  public recipient: Party;
  public sender: Party;
  public status: ShipmentStatus;
  public summarizedStatus: SummarizedShipmentStatus;
  public numberOfParcels: number;
  public isDomestic: boolean;
  public canOpenParcelLocker: boolean;
  public weight: string;
  public length: string;
  public width: string;
  public height: string;
  public weightUnit: string;
  public dimensionUnit: string;
  public labels: Label[];
  public statusMessage?: string;
  public totalAmount?: number;
  public unpaidAmount?: number;
  public registrationKey?: string;
  public canBeDeleted: boolean;
  public canBeDroppedOffAtSelfServiceInPostoffice: boolean;
  public canBeDroppedOffAtPostboxOrParcelPoint: boolean;
  public estimatedDeliveryDateMessage: string;
  public estimatedNumberOfDaysUntilDelivery: string;
  public createdDateTime?: Date;
  public deliverTo: string;
  public chargeSenderCard: boolean;

  // tslint:disable-next-line:cyclomatic-complexity
  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    switch (propertyName) {
      case 'createdDateTime':
        return (typeof propertyValue === 'string') ? new Date(propertyValue) : propertyValue;

      case 'customsInfo':
        return propertyValue ? new CustomsInfo(propertyValue) : undefined;

      case 'labels':
        if (!propertyValue || !Array.isArray(propertyValue)) {
          return [];
        }
        return propertyValue.map((value): Label => {
          return new Label(value);
        });

      case 'options':
        return propertyValue ? new ShipmentOptions(propertyValue) : undefined;

      case 'recipient':
      case 'sender':
        if (!propertyValue) {
          // TODO: TP-8498 Throw an error when data is missing.
          // throw new Error(`Missing value for Shipment.${propertyName}`);
          return this.getUnknownParty(propertyName);
        }
        return new Party(propertyValue);

      case 'status':
        return propertyValue ? propertyValue : ShipmentStatus.Unknown;

      default:
        return super.coercePropertyType(propertyName, propertyValue);
    }
  }

  private getUnknownParty(propertyName: string): Party {
    return new Party({
      name: `Unknown ${propertyName}`,
      address: {
        country: 'Unknown country',
      },
    });
  }
}
